export class QuestionnaireAnswerLibraryPutRequest {
  isModelAnswer!: boolean
  version!: number
  constructor(isModelAnswer:boolean, version: number) {
    this.isModelAnswer = isModelAnswer
    this.version = version
  }
}
